export default __webpack_public_path__ + "media/apps/Configurator/images/icon-camera-75fc42f2db37766f2e7bf5614cf30754.png";